import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '@/common/SafeIcon';

const { FiLayers } = FiIcons;

const NoSchemeSelected = () => (
  <div className="flex flex-col items-center justify-center py-32 bg-white rounded-[2rem] border-2 border-dashed border-surface-200 px-6 text-center">
    <div className="w-20 h-20 bg-primary-50 rounded-3xl flex items-center justify-center mb-6 border border-primary-100">
      <SafeIcon icon={FiLayers} className="w-10 h-10 text-primary-400" />
    </div>
    <h2 className="text-xl font-black text-surface-900 mb-2 uppercase tracking-tight">No Scheme Selected</h2>
    <p className="text-surface-500 max-w-sm text-sm font-medium">
      Please select a scheme from the dropdown in the top navigation bar to view data.
    </p>
  </div>
);

export default NoSchemeSelected;